import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getTermsUrl } from 'helpers/link-generation';
import { selectActiveVenue, selectUserVenues } from 'selectors/general';

import PrivacyFooter from './PrivacyFooter';

const mapStateToProps = state => {
  const { venueId: activeVenueId } = selectActiveVenue(state);
  const venuesList = selectUserVenues(state);

  return {
    standardTermsUrl: getTermsUrl(venuesList, activeVenueId),
  };
};

const mergeProps = (stateProps, dispatchProps) => ({ ...stateProps, dispatchProps });

export default compose(injectIntl, connect(mapStateToProps, {}, mergeProps))(PrivacyFooter);
